if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        
        // Lógica de extras
        const extraProductId = formData.get('extra-product-id');
        const personalizationProductId = formData.get('personalization-product-id');
        const addonCount = typeof this.form.getAddonCount === 'function' ? this.form.getAddonCount() : 0;
        const personalizationSelected =
          typeof this.form.hasPersonalization === 'function' && this.form.hasPersonalization();
        const hasExtras =
          (addonCount > 0 && extraProductId) ||
          (personalizationSelected && personalizationProductId);

        if (hasExtras) {
          // Se houver extras, usamos o formato de múltiplos itens (JSON)
          const items = [];
          const bundleId = `bundle_${Date.now()}_${Math.floor(Math.random() * 1000)}`;
          
          // Item principal
          const mainItem = {
            id: formData.get('id'),
            quantity: formData.get('quantity') || 1,
            properties: {
              '_bundle_id': bundleId,
              '_extra_count': (addonCount + (personalizationSelected ? 1 : 0)).toString()
            }
          };
          
          // Extrair propriedades do formData
          for (let [key, value] of formData.entries()) {
            if (key.startsWith('properties[')) {
              const propKey = key.replace('properties[', '').replace(']', '');
              mainItem.properties[propKey] = value;
            }
          }
          items.push(mainItem);
          
          // Patches, badges e restantes opções de 2 €.
          if (addonCount > 0 && extraProductId) {
            items.push({
              id: extraProductId,
              quantity: addonCount * Number(mainItem.quantity),
              properties: {
                '_bundle_id': bundleId,
                '_is_extra': 'true',
                '_extra_type': 'addon'
              }
            });
          }

          // Uma personalização de 3 € ou 5 € por cada artigo adicionado.
          if (personalizationSelected && personalizationProductId) {
            items.push({
              id: personalizationProductId,
              quantity: Number(mainItem.quantity),
              properties: {
                '_bundle_id': bundleId,
                '_is_extra': 'true',
                '_extra_type': 'personalization'
              }
            });
          }

          const body = JSON.stringify({
            items,
            sections: this.cart ? this.cart.getSectionsToRender().map((section) => section.id) : [],
            sections_url: window.location.pathname
          });

          config.headers['Content-Type'] = 'application/json';
          config.body = body;
        } else {
          if (this.cart) {
            formData.append(
              'sections',
              this.cart.getSectionsToRender().map((section) => section.id)
            );
            formData.append('sections_url', window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          }
          config.body = formData;
        }

        fetch(`${routes.cart_add_url}.js`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
